import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../css/VideoDialog.css';
import { useAuth } from './auth/AuthContext';
import { GridComponent, ColumnsDirective, ColumnDirective, Sort, Inject, Filter } from '@syncfusion/ej2-react-grids';

export function FilesFinder(args) {
    var [videos, setVideos] = useState([]);
    var [srchArchiveName, setSrchArchiveName] = useState('');
    var [srchFolderName, setSrchFolderName] = useState('');
    var [srchVidName, setSrchVidName] = useState('');
    var [selectedRow, setSelectedRow] = useState('');
    const [loading, setLoading] = useState('');
    const { secureFetch } = useAuth();
    const filterSettings = { type: 'Excel' };

    async function searchVideo(e) {
        e.preventDefault();

        setLoading('loading');
        //console.log('Search video clicked. search value = ' + srchVidName);
        //let url = 'api/mediasearcher/FindMedia?';
        if (!(srchVidName || srchArchiveName || srchFolderName)) {
            alert('Please enter at least one search criteria');
            return;
        }
        let url = 'api/mediasearcher/GetChildren?';
        let params = {};
        if (srchVidName) {
            params.query = srchVidName;
        }
        if (srchArchiveName) {
            params.archiveName = srchArchiveName;
        }
        if (srchFolderName) {
            params.folderName = srchFolderName;
        }

        url += new URLSearchParams(params).toString();
        const response = await secureFetch(url);
        if (response.ok) {
            const data = await response.json();
            data.forEach((video) => {
                video.creationDate = new Date(video.creationDate);
                video.size = formatFileSize(video.size);
            });
            setVideos(data);
        }
        else {
            console.error('Error in fetch call:', response.status, response.statusText);
        }
        setLoading('');
    }

    function formatFileSize(size) {
        let unit = 'bytes';
        if (size > 1024) {
            size /= 1024;
            unit = 'KB';
        }
        if (size > 1024) {
            size /= 1024;
            unit = 'MB';
        }
        return `${Math.round(size)} ${unit}`;
    }

    return (
        <div className={`container mt-3 ${loading}`}>
            <h2>Find Files</h2>
            <form>
                <div class="row mb-3">
                    <div className="col-sm-2">
                        <label for="srchVidName">Archive Name:</label>
                    </div>
                    <div className="col-sm-8 me-auto">
                        <input type="text" class="form-control" placeholder="Search files within Archive"
                            name="srchArchiveName" value={srchArchiveName} onChange={e => setSrchArchiveName(e.target.value)}></input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div className="col-sm-2">
                        <label for="srchFolderName">Folder Name:</label>
                    </div>
                    <div className="col-sm-8 me-auto">
                        <input type="text" class="form-control" placeholder="Search files under Folder"
                            name="srchFolderName" value={srchFolderName} onChange={e => setSrchFolderName(e.target.value)}></input>
                    </div>
                </div>
                <div class="row mb-3">
                    <div className="col-sm-2">
                        <label for="srchVidName">File Name:</label>
                    </div>
                    <div className="col-sm-8 me-auto">
                        <input type="text" class="form-control" placeholder="Partial or Full File Name"
                            name="srchVidName" value={srchVidName} onChange={e => setSrchVidName(e.target.value)}></input>
                    </div>
                </div>
                <div className="toolbar mb-3">
                    <button type="submit" class="btn btn-primary" onClick={searchVideo}>Submit</button>
                </div>
                </form>
                <div className="card">
                    <div className="card-body">
                        <GridComponent dataSource={videos} height='40vh' allowSorting={true} allowFiltering={true} filterSettings={filterSettings}>
                            <ColumnsDirective>
                                <ColumnDirective field='name' width='40%' headerText='Name'></ColumnDirective>
                                <ColumnDirective field='creationDate' width='10%' type="date" format='dd-MMM-yyyy' headerText='Creation Date'></ColumnDirective>
                            <ColumnDirective field='size' width='10%' headerText='Size' textAlign='Right' />
                            <ColumnDirective field='filePath' width='40%' headerText='File Path'></ColumnDirective>
                            </ColumnsDirective>
                            <Inject services={[Sort, Filter]} />
                        </GridComponent>
                    </div>
                </div>
                {loading && <div class='overlay'></div>}
        </div>
    );
}

